<template>
  <div class="SelectionGroup">
    <van-nav-bar
      title="选择群"
      right-text="确定"
      fixed
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <div class="select">
      <van-cell-group v-for="item in groupList" :key="item+''" :style="{padding:'0 10px'}">
        <van-radio-group v-model="radio" class="radio">
          <van-radio :name="item.ug_id">
            <van-cell :title="item.ug_name" :value="item.group_user.length+'人'">
              <van-image
                class="err-image-header"
                slot="icon"
                width="30px"
                round
                height="30px"
                :src="attach_url+item.ug_icon"
              />
            </van-cell>
          </van-radio>
        </van-radio-group>
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelectionGroup",
  data() {
    return {
      newFriend_id: "", // 新朋友id
      groupList: [],
      radio: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre
    };
  },
  created() {
		this.getStateConfigs();
    var params = this.$route.query;
    this.newFriend_id = params.u_id;
    this.loadData();
  },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    loadData() {
      var params = {
        u_id: this.u_id,
        token: this.token,
        newFriend_id: this.newFriend_id
      };
      var url = this.Conf.serverUrl + "GroupChatroom/getGroupByGroupOwner" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          this.groupList = response.data.result;
          // console.log(response.data);
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push("/NewFriends");
    },
    // 新朋友加入群
    onClickRight() {
      var params = {
        newFriend_id: this.newFriend_id,
        u_id: this.u_id,
        group_id: this.radio,
        token: this.token
      };

      var url = this.Conf.serverUrl + "Groups/addNewFriendGroup";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
              this.loadData();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {
          // console.log(error);
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/AddressList/SelectionGroup.vue